import {
    ExtendedConstructionNumber,
    GeneratedConstructionNumberStatus,
} from '@bpd-library/utilities';

import { useTranslate } from '../../hooks';
import { FormattedStatus } from './status';

const CONSTRUCTION_NUMBER_STATUS_TRANSLATIONS: {
    [key in GeneratedConstructionNumberStatus]: string;
} = {
    InPreparation: 'StatusLabel-InVoorbereiding',
    Available: 'Enum-ConstructionNumberStatus-Vrij',
    InOption: 'houses-overview-status-option',
    Sold: 'Enum-ConstructionNumberStatus-Verkocht',
    Reserved: 'Reserved',
    Rented: 'Enum-ProjectStatus-Verhuurd',
    UnderConstruction: 'UnderConstructionInhabited',
    AssigningOn: 'StatusLabel-AssigningOn',
};

/**
 * @description Takes an Extended Construction number and returns translated status and color
 * @param {ExtendedConstructionNumber} constructionNumber
 * @return {*}  {(FormattedStatus | undefined)}
 */
const formatConstructionNumberStatus = (
    constructionNumber: ExtendedConstructionNumber,
): FormattedStatus | undefined => {
    const { status, projectPhase } = constructionNumber;

    switch (status) {
        case 'InPreparation':
            return {
                color: 'grey',
                label: useTranslate(CONSTRUCTION_NUMBER_STATUS_TRANSLATIONS[status]),
            };
        case 'Available':
            return {
                color: 'green',
                label: useTranslate(
                    constructionNumber.projectPhase?.isRental
                        ? 'Enum-ProjectStatus-InVerhuur'
                        : CONSTRUCTION_NUMBER_STATUS_TRANSLATIONS[status],
                ),
            };
        case 'InOption':
            return {
                color: 'orange',
                label: useTranslate(CONSTRUCTION_NUMBER_STATUS_TRANSLATIONS[status]),
            };
        case 'Sold':
            return {
                color: 'red',
                label: useTranslate(CONSTRUCTION_NUMBER_STATUS_TRANSLATIONS[status]),
            };
        case 'Rented':
            return {
                color: 'red',
                label: useTranslate(CONSTRUCTION_NUMBER_STATUS_TRANSLATIONS[status]),
            };
        case 'Reserved':
            return {
                color: 'orange',
                label: useTranslate(CONSTRUCTION_NUMBER_STATUS_TRANSLATIONS[status]),
            };
        case 'UnderConstruction':
            return {
                color: 'purple',
                label: useTranslate(CONSTRUCTION_NUMBER_STATUS_TRANSLATIONS[status]),
            };
        case 'AssigningOn':
            const allocationDate = new Date(projectPhase?.allocationDate!).toLocaleDateString(
                window.__ENVIRONMENT_DETAILS__.languageIsoCode,
                {
                    day: 'numeric',
                    month: 'short',
                },
            );

            return {
                label: useTranslate('StatusLabel-AssigningOn.Dynamic', {
                    replace: [{ id: 'Date', value: allocationDate }],
                }),
                color: 'orange',
            };
    }

    return;
};

export { formatConstructionNumberStatus, CONSTRUCTION_NUMBER_STATUS_TRANSLATIONS };
